import { useCallback, useEffect, useState } from "react";
import { RootState } from "../../Store";
import { useDispatch, useSelector } from "react-redux";
import { removeToast } from "../../Slice/ToastSlice";
import css from './ToastComponent.module.scss';

interface ToastComponentProps {
  durationSeconds?: number;
}

interface ToastItemProps {
  id: number;
  message: string;
  durationSeconds?: number;
  onRemove: (id: number) => void;
}

const ToastItem: React.FC<ToastItemProps> = ({ id, message, durationSeconds, onRemove }) => {
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    if (durationSeconds === undefined || !Number.isFinite(durationSeconds) || durationSeconds <= 0) {
      return;
    }

    const fadeTimeout = window.setTimeout(() => {
      setIsFading(true);
    }, durationSeconds * 1000);
    const removeTimeout = window.setTimeout(() => {
      onRemove(id);
    }, durationSeconds * 1000 + 500);

    return () => {
      window.clearTimeout(fadeTimeout);
      window.clearTimeout(removeTimeout);
    };
  }, [durationSeconds, id, onRemove]);

  return (
    <div className={`${css.toast} ${isFading ? css.fading : ''}`}>
      <span>{message}</span>
      <button onClick={() => onRemove(id)} className={css.closeBtn}>
        <i className="bi bi-x" style={{ fontSize: "35  px" }}></i>
      </button>
    </div>
  );
};

const ToastComponent: React.FC<ToastComponentProps> = ({ durationSeconds }) => {

  const dispatch = useDispatch();
  const toasts = useSelector((state: RootState) => state.toast.toasts);
  const handleRemove = useCallback((id: number) => {
    dispatch(removeToast(id));
  }, [dispatch]);

  const visibleToasts = toasts.slice(0, 3);
  const hiddenCount = toasts.length - visibleToasts.length;

  return (
    <div>
      <div className={css.container}>
        {visibleToasts.map((toast) => (
          <ToastItem
            key={toast.id}
            id={toast.id}
            message={toast.message}
            durationSeconds={toast.durationSeconds ?? durationSeconds}
            onRemove={handleRemove}
          />
        ))}

        {hiddenCount > 0 && (
          <div className={css.more}>
            +{hiddenCount} weitere
          </div>
        )}
      </div>
    </div>
  );
}

export default ToastComponent;